import { render, staticRenderFns } from "./HumanResource.vue?vue&type=template&id=a3915b74"
import script from "./HumanResource.vue?vue&type=script&lang=js"
export * from "./HumanResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports